<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form class="multi-col-validation mt-6">
        <v-row>
          <v-col cols="12">
            <span class="text--secondary">
              Какие счета CRM показывать гостю картой лояльности. У держателя их десяток,
              и половина уже не в ходу — программа собирается из тех, что перечислены здесь.
              Появится третий регион — добавьте его строкой, править код не нужно.
            </span>
          </v-col>

          <v-col
            v-for="(program, index) in programs"
            :key="index"
            cols="12"
          >
            <v-row dense>
              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model="program.name"
                  label="Программа"
                  hint="Как её увидит гость"
                  persistent-hint
                  dense
                  outlined
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model.number="program.bonusAccountTypeId"
                  label="Счёт бонусов"
                  hint="С него берётся остаток и ступень"
                  persistent-hint
                  type="number"
                  dense
                  outlined
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="3"
              >
                <v-text-field
                  v-model.number="program.spentAccountTypeId"
                  label="Счёт потраченного"
                  type="number"
                  dense
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="2"
              >
                <v-text-field
                  v-model.number="program.levelAccountTypeId"
                  label="Счёт ступени"
                  hint="0 — с бонусного"
                  persistent-hint
                  type="number"
                  dense
                  outlined
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                md="1"
                class="d-flex align-center"
              >
                <v-btn
                  icon
                  :aria-label="`Убрать программу ${program.name}`"
                  @click="removeProgram(index)"
                >
                  <v-icon>{{ icons.mdiDelete }}</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-btn
              outlined
              small
              @click="addProgram"
            >
              <v-icon
                size="18"
                class="me-2"
              >
                {{ icons.mdiPlus }}
              </v-icon>
              <span>Добавить программу</span>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-alert
              text
              color="info"
              dense
            >
              Ступень по умолчанию берётся с бонусного счёта. На дисконтном рядом с ней лежат
              служебные скидки — «Менеджмент 30%», «Бар 100», — и сотруднику приложение
              показало бы их как его уровень.
            </v-alert>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              :loading="saving"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="fetch"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiDelete, mdiPlus } from '@mdi/js'

export default {
  name: 'LoyaltyProgramSettingForm',
  data: () => ({
    icons: { mdiDelete, mdiPlus },
  }),
  computed: {
    ...mapState('loyaltyProgramSettings', ['programs', 'saving']),
  },
  async created() {
    await this.fetch()
  },
  methods: {
    ...mapActions('loyaltyProgramSettings', ['fetch', 'update', 'addProgram', 'removeProgram']),
    async saveData() {
      await this.update()
    },
  },
}
</script>
